<template>
  <el-carousel id="container" trigger="click" height="384px">
    <el-carousel-item v-for="image in images" :key="image.id">
      <div
        class="image"
        :style="{
          background: 'url(' + image.path + ') no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'}"
      >
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'BannerCarousel',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

#container .image{
  height: 384px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/BannerCarousel.vue